<template>
  <div>
    <wc-section-title :title='profile.name_display'></wc-section-title>
    <router-view
      @update='update'
    ></router-view>
  </div>
</template>

<script>
import staffingAPI from '@/modules/staffing/api/staffing'

export default {
  name: 'profile-base',
  computed: {
    profile () {
      return this.$store.state.auth.profile
    },
    menu () {
      return [
        {
          title: 'Tasks',
          icon: this.$icons.tasks.icon,
          route: { name: 'MyTasks' }
        },
        {
          title: 'Profile',
          icon: this.$store.state.icons.modules.profile.icon,
          route: { name: 'Profile' }
        },
        {
          title: 'Change Password',
          icon: 'mdi-lock',
          route: { name: 'ChangePassword' }
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', this.profile.name_display)
    this.$store.dispatch('loadMainMenu', this.menu)
  },
  methods: {
    async update (profile) {
      this.isLoading = true
      let newProfile = await staffingAPI.updateProfile(profile)
      this.$store.dispatch('loadProfile', newProfile)

      this.isLoading = false
    }
  }
}
</script>
